import { render, staticRenderFns } from "./mascots.vue?vue&type=template&id=dcbadb32"
var script = {}
import style0 from "./mascots.vue?vue&type=style&index=0&id=dcbadb32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports